import React from "react";
import { Typography, Paper } from "@mui/material";

/** Small uppercase label that groups related fields within a wizard step. */
export const SectionLabel = ({ children }: { children: React.ReactNode }) => (
  <Typography
    sx={{
      fontSize: 11,
      fontWeight: 800,
      letterSpacing: 0.5,
      textTransform: "uppercase",
      color: "text.secondary",
      mb: 1,
    }}
  >
    {children}
  </Typography>
);

/** Friendly name for a detected git provider (from the validation icon type). */
export const PROVIDER_LABEL: Record<string, string> = {
  github: "GitHub",
  gitlab: "GitLab",
  bitbucket: "Bitbucket",
  git: "Git",
};

/** Consistent card shell so every wizard step looks the same. */
export const WizardCard = ({ children }: { children: React.ReactNode }) => (
  <Paper variant="outlined" sx={{ borderRadius: 1, p: { xs: 2, sm: 2.5 } }}>
    {children}
  </Paper>
);
